/* eslint-disable no-underscore-dangle */
import React, { memo } from 'react';
import PropTypes from 'prop-types';
import volume0 from 'assets/icons/volume_0.svg';
import volume50 from 'assets/icons/volume_1_50.svg';
import volume100 from 'assets/icons/volume_51_100.svg';
import Slider from '../Slider';
import VolumeSeekerStyled from './styles/VolumeSeekerStyled';

const VolumeSeeker = ({ volume, setVolume, getSeeking, isMobile, muted, unMute, mute }) => {
  const mutePlayer = (state) => {
    const videos = document.getElementsByTagName('video');
    for (let i = 0; i < videos.length; i++) {
      videos[i].muted = state;
    }
  };

  const handleVolumeClick = () => {
    if (window.__muted_toggled) {
      window.__muted_toggled = undefined;
      return;
    }

    if (!isMobile) {
      if (muted) {
        unMute();
      } else {
        mute();
      }
    } else if (muted) {
      unMute();
      mutePlayer(false);
    } else {
      mute();
      mutePlayer(true);
    }
  };

  const iconName = () => {
    // change volume icon
    let icon = '';
    if (muted || volume === 0) {
      icon = volume0.id;
    } else if (volume <= 50) {
      icon = volume50.id;
    } else {
      icon = volume100.id;
    }

    return icon;
  };

  if (isMobile && muted) {
    mutePlayer(true);
  }

  return (
    <VolumeSeekerStyled>
      <Slider
        max={100}
        currentTime={muted ? 0 : volume}
        progress={100}
        onChange={setVolume}
        drawThumbnail={false}
        offset={0}
        secondsPrefix="00:00:"
        minutesPrefix="00:"
        width={80}
        type="volume"
        icon={iconName()}
        onVolumeIconClick={handleVolumeClick}
        getSeeking={getSeeking}
        isMobile={isMobile}
      />
    </VolumeSeekerStyled>
  );
};

VolumeSeeker.propTypes = {
  muted: PropTypes.bool.isRequired,
  volume: PropTypes.number.isRequired,
  mute: PropTypes.func.isRequired,
  unMute: PropTypes.func.isRequired,
  setVolume: PropTypes.func.isRequired,
  getSeeking: PropTypes.func,
  isMobile: PropTypes.bool,
};

VolumeSeeker.defaultProps = {
  getSeeking: Function.prototype,
  isMobile: false,
};

export default memo(VolumeSeeker);
